import { type Enum, type FeatureFlagValue, type VariantValue } from "@/types";

export const VARIANT_TREATMENT: VariantValue = "treatment";
export const VARIANT_CONTROL: VariantValue = "control";
export const FEATURE_FLAG_ACTIVE: FeatureFlagValue = "on";
export const FEATURE_FLAG_INACTIVE: FeatureFlagValue = "off";

// Experiments Keys;
export const EXPERIMENTS_AUTO_DISMISS_BRANCH_JOURNEY = "web-acq-848-programatic-branch-banner-dismissal"; // I didn't set up the experiment; blame Jeromy for the typo :)
export const EXPERIMENTS_DISABLE_VIDEO_DOWNLOAD_BEFORE_PLAY = "web-acq-1239-disable-video-download";
export const EXPERIMENTS_APP_DOWNLOAD_KEY = "web-sc-191972-app-download-pop-up";
export const EXPERIMENTS_MOTHERS_DAY = "mothers-day";
export const EXPERIMENTS_LOHP_VPM = "sc-183446-value-prop-messaging";
export const EXPERIMENTS_POSTS_FAVORITE_VPM = "coco-65-follow-and-like-tooltips";
export const EXPERIMENTS_CREATOR_FOLLOW_VPM = "coco-65-follow-and-like-tooltips";
export const EXPERIMENTS_CREATOR_GIFT_GUIDES = "web-sc-221303-creator-page-gift-guides";
export const EXPERIMENTS_SHARE_FAVORITES_VPM = "web-sc-206020-share-favorite-products-vpm";
export const EXPERIMENTS_DYNAMIC_LOADING_STATE = "web-sc-251200-dynamic-loading-state";
export const EXPERIMENTS_BEAUTY_SALE = "web-sc-261942-beauty-banner-flag";
export const EXPERIMENTS_TIKTOK_IAB_NOTIFICATION = "web-sc-249095-tiktok-iab-notification";
export const EXPERIMENTS_TRENDING_POST_CAROUSEL = "web-sc-268711-trending-content-carousel-on-web-creator-shop";
export const EXPERIMENTS_PRODUCTS_ABOVE_FOLD_ON_POST_DETAILS = "web-acq-1483-products-above-fold-on-post-details";
export const EXPERIMENTS_CONSUMER_SEARCH = "web-cs-181-consumer-search-v4";
export const EXPERIMENTS_SINGLE_COLUMN = "coco-139-single-column-more-from";

// Feature Flag Keys
export const FLAG_AUTH0_PASSWORD_RESET = "retain-2071-auth0-password-reset-consumer";
export const FLAG_CREATOR_SHOP_POST_SEARCH = "web-sc-237710-creator-shop-post-search-bar";
export const FLAG_IMPRESSIONS_POSTS = "web-acq-275-impressions";
export const FLAG_IMPRESSIONS_PRODUCTS = "web-acq-617-impressions-products";
export const FLAG_IMPRESSIONS_VISIT_SHOP = "web-acq-751-impressions-visits-creator-shop";
export const FLAG_IMPRESSIONS_VISIT_POST = "web-acq-751-impressions-visits-post";
export const FLAG_DUAL_ATTRIBUTION = "web-re-541-dual-attribution";
export const FLAG_PRICE_DROP_BADGE = "web-acq-421-price-drop-badging-on-web-products";
export const FLAG_POST_WO_PRODUCTS = "cc-2132-post-wo-products";
export const FLAG_WEB_REGISTRATION_BANNER = "web-coco-3-consumer-web-registration-banner";
export const FLAG_GET_THE_APP_BANNER = "acq-1640-enable-get-the-app-toggle-button";
export const FLAG_CONSUMER_SEARCH_AUTOCOMPLETE = "web-cs-678-consumer-search-autocomplete";
export const FLAG_CREATOR_SHOP_SEARCH = "web-cs-699-creator-shop-search";
export const FLAG_BRAND_PROFILES = "acq-1948-brand-profiles";

export const basicVariants = {
  CONTROL: "control",
  TREATMENT: "treatment",
} as const;

export type BasicVariants = Enum<typeof basicVariants>;

export const experimentVariants = {
  CONTROL: "control",
  A: "a-variant",
  B: "b-variant",
  C: "c-variant",
} as const;

export type ExperimentVariants = Enum<typeof experimentVariants>;
